import React, { Component } from "react";
import MedicineList from "./MedicineList";
import MedicineAdd from "./MedicineAdd";
import MedicineEdit from "./MedicineEdit";

class Medicine extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "List",
      data: null
    };
    this.handleClick = this.handleClick.bind(this);
  }
  render() {
    if (this.state.mode === "List") {
      return <MedicineList onClick={this.handleClick} />;
    } else if (this.state.mode === "Add") {
      return (
        <MedicineAdd
          pData={this.state.data}
          onClick={this.handleClick}
          source="list"
        />
      );
    } else if (this.state.mode === "Edit") {
      return (
        <MedicineEdit
          pData={this.state.data}
          onClick={this.handleClick}
          source="list"
        />
      );
    }
  }

  handleClick(mode, data) {
    this.setState({ data, mode });
  }
}

export default Medicine;
